// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c8d14685","455":"95b9899c"}[chunkId] + ".chunk.js";
};